import { render, staticRenderFns } from "./VAutocompleteFiscalRegla.vue?vue&type=template&id=152ea516&scoped=true"
import script from "./VAutocompleteFiscalRegla.vue?vue&type=script&lang=js"
export * from "./VAutocompleteFiscalRegla.vue?vue&type=script&lang=js"
import style0 from "./VAutocompleteFiscalRegla.vue?vue&type=style&index=0&id=152ea516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ea516",
  null
  
)

export default component.exports